module.exports = __webpack_public_path__ + "front/img/13.8d983d82.png";